export enum DetailedQuoteTab {
  CHART = 'CHART',
  SUMMARY = 'SUMMARY',
  MORE_DETAILS = 'MORE_DETAILS'
}
